<template>
    <v-ons-page>
        <div class="background"></div>
        <qf-toolbar></qf-toolbar>
        <div class="list">
            <v-ons-card class="qf-card-item" v-for="singleCollection in collectionLists" :key="singleCollection.id" @click="openSingleCollection(singleCollection)">
                <img v-if="singleCollection.imageLink" :src="singleCollection.imageLink" :alt="singleCollection.title" style="width: 100%"/>
                <img v-else :src="defaultLogo" :alt="singleCollection.title" style="width: 100%" />
                <div class="qf-collection-title-wrapp">
                    <div  class="qf-collection-avatar-wrapp">
                        <img v-if="singleCollection.curator" :src="singleCollection.curator.avatar" alt="">
                        <svg v-else aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-user-alt fa-w-16 fa-2x"><path fill="currentColor" d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z" class=""></path></svg>
                    </div>
                    <div class="title">
                        <!--							<span v-if="singleCollection.link"><v-ons-icon icon="fa-external-link-alt"></v-ons-icon> </span>-->
                        {{singleCollection.title}}
                    </div>
                </div>
            </v-ons-card>
        </div>
        <qf-spinner :showing="loadingData" message="Loading collection data..."></qf-spinner>
    </v-ons-page>
</template>

<script>
import SingleCollection from "./SingleCollection";
import SingleExtCollection from "./SingleExtCollection";
import QfSpinner from "../shared/QfSpinner";
import Login from "../login/Login";
import Api from '@/services/api';

export default {
    name: "CollectionsHome",
    components: {QfSpinner},
    methods: {
        openMainMenu() {
            this.$store.commit('splitter/toggle');
        },
        openSingleCollection(oneCollection) {
            if(oneCollection.link){
                this.$store.commit('navigator/push', {
                    extends: SingleExtCollection,
                    data() {
                        return oneCollection;
                    }
                })
            }else{
                this.loadingData = true;
                let self = this;
                Api().get('/collections/'+oneCollection.id).then(response => {
                    self.loadingData = false;
                    //console.log("Selected collection details: ", response.data);
                    this.$store.commit('navigator/push', {
                        extends: SingleCollection,
                        data() {
                            return response.data;
                        }
                    });
                }).catch(err => {
                    self.loadingData = false;
                    if(err.status === 401){
                        self.$ons.notification.toast({
                            message: 'Your session has expired. Redirecting to login...',
                            buttonLabel: '',
                            timeout: 2000
                        }).then(function () {
                            self.$store.commit('navigator/push', {
                                extends: Login,
                            });
                        });
                    }
                });

            }
        },
        moveItem(dataArray, from, to) {
            // remove `from` item and store it
            var f = dataArray.splice(from, 1)[0];
            // insert stored item into position `to`
            dataArray.splice(to, 0, f);
            return dataArray;
        }
    },
    data() {
        return {
            title: 'Your collections in CapeCloud',
            collectionLists: [],
            token: '',
            baseUrl: process.env.VUE_APP_BASE_URL,
            loadingData: false
        }
    },
    computed: {
        defaultLogo(){
            return `https://`+process.env.VUE_APP_VARIANT+`.capecloud.ch/images/placeholder-logo.png`
        }
    },
    created() {
        this.token = this.$getCookie('access_token');
        this.loadingData = true;
        Api().get('collections').then(response => {
            this.loadingData = false;
            //console.log("Collections: ", response.data);
            if(process.env.VUE_APP_VARIANT === 'ehoffmann' && response.data.length > 0){
                let prioCollections = [441];
                let self = this;
                response.data.forEach(function(collection, index){
                    if(prioCollections.indexOf(collection.id) != -1 ){
                        self.collectionLists = self.moveItem(response.data, index, 0);
                    }
                });
            }else {
                this.collectionLists = response.data;
            }
        }).catch(err => {
            this.loadingData = false;
            console.log(err);
            //reject(err);
        });
    },
}
</script>

<style scoped>
.background{background-color: #181818}
.qf-collection-title-wrapp {
    display: flex;
    align-items: center;
    padding: 0 15px;
}
.qf-collection-avatar-wrapp img,
.qf-collection-avatar-wrapp svg {
    width: 60px;
    height: 60px;
    object-fit: cover;
    padding: 2px;
    box-sizing: border-box;
    border-radius: 50%;
    position: relative;
    margin-top: -22px;
    margin-bottom: 8px;
}
.qf-collection-avatar-wrapp svg {
    padding-top: 12px;
    box-sizing: border-box;
}
.qf-collection-avatar-wrapp {
    margin-right: 20px;
}
.list{background-image: none}
</style>
